import React, {
  DetailedHTMLProps,
  HTMLAttributes,
  LabelHTMLAttributes,
  PropsWithChildren,
} from 'react'

interface FormControllerProps {
  children: React.ReactNode
}

export const FormController = ({
  children,
}: PropsWithChildren<FormControllerProps>) => {
  return <div className="flex w-full flex-col gap-1.5">{children}</div>
}

const FormControllerLabel = ({
  children,
  ...props
}: DetailedHTMLProps<
  LabelHTMLAttributes<HTMLLabelElement>,
  HTMLLabelElement
>) => {
  return (
    <label
      className="text-secondary-500 w-full text-sm font-medium dark:text-white"
      {...props}
    >
      {children}
    </label>
  )
}

const FormControlerInput = ({
  children,
  ...props
}: HTMLAttributes<HTMLParagraphElement>) => {
  return (
    <p
      className="text-secondary-500 text-sm dark:text-white"
      {...props}
    >
      {children}
    </p>
  )
}

const FormControllerError = ({
  children,
  ...props
}: HTMLAttributes<HTMLParagraphElement>) => {
  return (
    <p
      className="text-danger-default text-xs"
      {...props}
    >
      {children}
    </p>
  )
}

const FormControllerHelper = ({
  children,
  ...props
}: HTMLAttributes<HTMLParagraphElement>) => {
  return (
    <p
      className="text-secondary-300 dark:text-secondary-300 text-xs"
      {...props}
    >
      {children}
    </p>
  )
}

FormController.Label = FormControllerLabel
FormController.Input = FormControlerInput
FormController.Error = FormControllerError
FormController.Helper = FormControllerHelper

FormController.displayName = 'FormController'
